import React from "react";
import ConditionalTooltipWrapper from "../../../helpers/components/ConditionalTooltipWrapper";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ChipIcon(_ref) {
  var icon = _ref.icon,
    tooltipContent = _ref.tooltipContent;
  if (!icon) {
    return null;
  }
  var Icon = icon;
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsx(Icon, {
      size: "1rem",
      color: "currentColor"
    })
  });
}